import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let cached: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (cached) return cached;

  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !key) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn(
        "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — falling back to seed data.",
      );
    }
    return null;
  }

  cached = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  });
  return cached;
}

export const SITE_URL =
  (import.meta.env.VITE_SITE_URL as string | undefined) ?? "https://casinomenu.se";

export const GLOBAL_FALLBACK_AFFILIATE_URL =
  (import.meta.env.VITE_GLOBAL_FALLBACK_AFFILIATE_URL as string | undefined) ??
  "https://betiniase.wermifal.com/?mid=303363_2130914";
